<template>
    <div  class="fixed-header">
      <div >
       <div id="title">
         	<div id="s-Page_Header" class="group">

           <div id="s-Image_1" class="sidebyside widthbanner">
                 <img src="../assets/banner.png" class="imgbanner" >
             </div>

             <div id="s-Image_2" class="sidebyside widthother  paragraphname" >
                 <div class="rightalign "><button class="btn-blue-save signInButton" type="submit"  @click="signin">Sign In</button></div>
             </div>

        </div>
           <div id="s-Page_Header" class="group" >
               <img src="../assets/car-image.png" class="carimg" >
           </div>
    </div>

    </div>
      <bottom-footer></bottom-footer>
     </div>

</template>
<script>
import BottomFooter from '@/components/BottomFooter.vue'
export default {
  data () {
    return {

    }
  },
  methods: {
    signin: function () {
      this.$router.push('/login')
    } },
  components: {
    BottomFooter
  }
}
</script>
<style scoped>
.group {display: flex;
    flex-direction: row;
    border: 1px black solid;
    margin: 0 auto;}
.sidebyside {
    float:left;
}

.rightalign{
    float: right;
margin-right: 2%;
   margin-top:6%;
}
.widthbanner{
      width:80%;
      height: 70px;
}
.widthother{
      width:20%;
}

    .imgbanner {
   	height: 60px;
	}
    .carimg {

width:100%;
	height: 25%;
	}
   .paragraph {
    font-size: 8pt;
        font-family: Rockwell, Arial;
}
 .paragraphname {
    font-size: 10pt;
        font-family: Rockwell, Arial;
}
.signInButton{
    margin: 0px;
    padding: 0px;
    border-radius: 6px;
    font-size : 10px;
    height: 30px;
    width: 100px;
}
</style>
